<template>
  <div style="overflow-y: hidden">
    <div class="temp_top">
      <label>稿件提交提示信息：</label>
    </div>
    <div class="temp_middle" align="center">
      <a-textarea id="textarea" v-model="submitMessage"></a-textarea>
      <a-button type="primary" @click="submit" style="margin-top: 10px"
        >保存</a-button
      >
    </div>
    <!-- <div class="bottom" id="btn-div"  style="margin-top:40px;">
      
    </div> -->
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "submitMessage",
  data() {
    return {
      submitMessage: "",
    };
  },
  created() {
    this.query();
  },
  methods: {
    query() {
      this.axios
        .get("/manuscriptTemplate/querySubmitMessage", {
          params: {
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.submitMessage = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询投稿须知失败！");
          }
        });
    },
    submit() {
      this.axios
        .post("/manuscriptTemplate/saveSubmitMessage", {
          submitMessage: this.submitMessage,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "保存成功！");
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "保存失败！");
          }
        });
    },
  },
};
</script>

<style scoped>
#textarea {
  width: 100%;
  height: 450px;
  margin-top: 10px;
}
.middle #btn {
  margin-top: 15px;
  margin-bottom: 15px;
}
/* #btn {
  color: #fff;
  background-color: #1abc9c;
  border-color: #1abc9c;
} */
</style>